module.exports = __webpack_public_path__ + "static/mizutama-136a3715c10156e5220af51038f2ad50.png";